<template>
    <header class="fixed top-0 left-0 w-full z-50">
        <LazyLayoutsDefaultHeader
            key="desktop-navbar"
            class="hidden lg:block w-full"
            :type="desktopHeaderType"
        />
        <LayoutsDefaultMobileNavbar class="lg:hidden" key="mobile-navbar" />
    </header>
    <main class="w-full overflow-x-clip pt-[var(--header-height,85px)]">
        <slot />
    </main>
    <footer>
        <LayoutsDefaultFooter />
    </footer>
</template>

<script lang="ts" setup>
const { y: pageScroll } = useWindowScroll();
const desktopHeaderType = computed(() => (pageScroll.value > 20 ? "small" : "large"));
</script>

<style></style>
